import { createSlice } from "@reduxjs/toolkit";

const reportManagementSlice = createSlice({
    name: 'reportManagement',
    initialState: {
        data: [],
        isLoading: false
    },
    reducers: {
        startLoading: (state) => { state.isLoading = true; },
        stopLoading: (state) => { state.isLoading = false; },
        getUpdateConfig: (state, action) => { state.data = action.payload; },
    }
});

const reportManagementActions = reportManagementSlice.actions;

export { reportManagementActions };
export default reportManagementSlice.reducer;